import { post, get, put, patch, remove } from "../../ApiService";
import { ApiUrl } from "../../ApiUrl";
import { GetEquipmentRegistryListParams } from "./types";

export const listEquipmentRegistry = async (
  params: GetEquipmentRegistryListParams,
  region: number,
  project: any,
  site: any
) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize)
      queryParams.append("pageSize", params.pageSize.toString());
    if (params.orderBy)
      queryParams.append("order_by", params.orderBy.toString());
    if (params.search) queryParams.append("search", params.search);
    if (params.regMake) queryParams.append("category", params.regMake);
    if (params.regModel) queryParams.append("model", params.regModel);
    if (params.fuelType) queryParams.append("brand", params.fuelType);
    if (params.contactNumber)
      queryParams.append("fuelType", params.contactNumber);
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);

    const queryString = queryParams.toString();
    const url = `${ApiUrl.equipmentModule.equipmentRegistry}${
      queryString ? `?${queryString}` : ""
    }&region=${region}&project=${project}&site=${site}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getEquipmentRegistryById = async (
  id: number,
  region: number,
  project: any
) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentRegistryById(
      id
    )}?region=${region}&project=${project}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const createEquipmentRegistry = async (
  data: any,
  region: number,
  project: any,
  site: any
) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentRegistry}?region=${region}&project=${project}&site=${site}`;
    const res = await post(url, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateEquipmentRegistry = async (
  id: number,
  data: any,
  region: number,
  project: any
) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentRegistryById(
      id
    )}?region=${region}&project=${project}`;
    const res = await put(url, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const deleteEquipmentRegistry = async (
  id: number,
  region: number,
  project: any
) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentRegistryById(
      id
    )}?region=${region}&project=${project}`;
    const res = await remove(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getListOfEquipmentRegistry = async (
  region: number,
  project: any,
  site: any
) => {
  try {
    const url = `${ApiUrl.equipmentModule.getListOfEquipmentRegistry}?region=${region}&project=${project}&site=${site}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const uploadEquipmentRegistry = async (
  data: FormData,
  region: number,
  project: any
) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentRegistryBulkUpload}?region=${region}&project=${project}`;
    const res = await post(url, data);
    return res;
  } catch (error: any) {
    return {
      success: false,
      message: error.response?.data?.message || "File upload failed",
      data: error.response,
    };
  }
};
